<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          @click:outside="closeModal"
          :retain-focus="false"
          width="999"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t("supplier.updateSupplier") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text mt-10">
              <v-form
                v-model="formValidated"
                v-on:submit.prevent="updateSupplierSubmit()"
                ref="form"
                lazy-validation
              >
                <v-row>
                  <v-col cols="3" class="text-center">
                    <div>
                      <img
                        style="
                          position: relative;
                          width: 190px;
                          height: 190px;
                          border-radius: 50%;
                        "
                        :src="
                          this.previewProfilePic
                            ? this.previewProfilePic
                            : '/img/No_Image_Available.jpg'
                        "
                        alt="John"
                      />
                      <img
                        @click="getFile"
                        src="/img/camera-icon.svg"
                        style="
                          position: absolute;
                          left: 17%;
                          top: 240px;
                          cursor: pointer;
                        "
                      />
                      <v-file-input
                        id="fileUpload"
                        accept="image/*"
                        hide-input
                        @change="onFileChanged"
                        prepend-icon=""
                      />
                    </div>
                    <div class="mt-4">
                      <strong>{{
                        supplier.supplierName
                          ? supplier.supplierName
                          : "John Doe"
                      }}</strong>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <v-row>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.supplierName") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span
                              >{{ $t("supplier.tooltip.supplierName") }}
                            </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.supplierName"
                          :placeholder="$t('feedMgt.supplierName')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.supplierName"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.phoneNumber")
                          }}<v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span
                              >{{ $t("supplier.tooltip.phoneNumber") }}
                            </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.phoneNo"
                          :placeholder="$t('feedMgt.phoneNumber')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.phoneNumber"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.emailAddress")
                          }}<v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span
                              >{{ $t("supplier.tooltip.emailAddress") }}
                            </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.email"
                          type="email"
                          :placeholder="$t('feedMgt.emailAddress')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.emailAddress"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.licenseNumber") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span
                              >{{ $t("supplier.tooltip.licenseNumber") }}
                            </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.licenseNumber"
                          placeholder="License  No.e.g.1762538162"
                          dense
                          outlined
                          required
                          :rules="supplierRules.licenseNumber"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.country") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("supplier.tooltip.country") }} </span>
                          </v-tooltip></label
                        >
                        <v-autocomplete
                          outlined
                          :items="countries"
                          item-value="Name"
                          :placeholder="$t('selectCountry')"
                          class="phone-drop rounded-r-0 outline-l-0"
                          v-model="supplier.countryId"
                          dense
                          ref="phoneSelect"
                          :rules="supplierRules.country"
                        >
                          <template v-slot:item="slotProps">
                            <i
                              :class="[
                                'mr-2',
                                'em',
                                `em-flag-${slotProps.item.Code.toLowerCase()}`,
                              ]"
                            ></i>
                            {{ `${slotProps.item.Name}` }}
                          </template>
                          <template slot="selection" slot-scope="data">
                            <span class="text-truncate">{{
                              `${data.item.Name}`
                            }}</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.city") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("supplier.tooltip.city") }} </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.city"
                          :placeholder="$t('city')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.city"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.zipCode") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("supplier.tooltip.zipCode") }} </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.zipcode"
                          :placeholder="$t('zipCode')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.zipCode"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.state") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("supplier.tooltip.state") }} </span>
                          </v-tooltip></label
                        >
                        <v-text-field
                          v-model="supplier.state"
                          :placeholder="$t('state')"
                          dense
                          outlined
                          required
                          :rules="supplierRules.state"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <label
                          >{{ $t("supplier.dropYourLogo") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span
                              >{{ $t("supplier.tooltip.dropYourLogo") }}
                            </span>
                          </v-tooltip></label
                        >
                        <v-file-input
                          accept="image/*"
                          type="file"
                          v-model="supplier.logoUrl"
                          :placeholder="$t('dragDropToUpload')"
                          dense
                          outlined
                          prepend-icon=""
                          append-icon="mdi-cloud-upload-outline"
                          readonly
                          @change="uploadLogoChange"
                        ></v-file-input>
                      </v-col>
                      <v-col cols="12">
                        <label>{{ $t("supplier.about") }}</label>
                        <v-textarea
                          dense
                          :placeholder="$t('about')"
                          outlined
                          v-model="supplier.about"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="8">
                            <label
                              >Select Ingredients
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span
                                  >{{ $t("supplier.tooltip.selectIngredient") }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-autocomplete
                              v-model="supplier.supplierIngredient"
                              :items="searchIngredients"
                              outlined
                              dense
                              multiple
                              chips
                              item-text="name"
                              item-value="id"
                              deletable-chips
                              :chip-append-icon="mdi - plus"
                              :chip-remove-icon="mdi - plus"
                              :placeholder="$t('search')"
                            >
                              <template v-slot:prepend-item>
                                <v-row class="d-flex align-center pt-5 pl-5">
                                  <v-col cols="7">
                                    <v-text-field
                                      v-model="searchIngredientData"
                                      @input="searchIngredient"
                                      prepend-inner-icon="mdi-magnify"
                                      outlined
                                      height="5px"
                                      :placeholder="$t('search')"
                                      dense
                                      class="shrink"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="5">
                                    <router-link
                                      :to="{ name: 'AddNewIngredient' }"
                                    >
                                      <p
                                        class="green--text text-decoration-underline body-2"
                                      >
                                        Add New Ingredient
                                      </p>
                                    </router-link>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="mr-2 px-5"
                    right
                    height="44"
                    depressed
                    color="primary"
                    @click="closeModal"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    type="submit"
                    right
                    height="44"
                    color="primary"
                    class="px-5"
                  >
                    {{ $t("confirm") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-dialog v-model="errorDialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5"> {{ $t("error") }} </v-card-title>

        <v-card-text>
          {{ errorText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text @click="errorDialog = false">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import countries from "@/constants/countries.js";
import { supplierRules } from "@/validations/FeedSupplierRules";
import { supplier } from "@/graphql/Supplier.gql";
import { updateSupplier, GetIngredients } from "@/graphql/Supplier.gql";
export default {
  apollo: {
    supplier: {
      query: supplier,
      fetchPolicy: "network-only",
      variables() {
        return {
          id: Number(this.supplierID),
        };
      },
      result({ data }) {
        let supplierIngredientIDs = data.supplier.supplierIngredient.map(
          item => {
            return item.ingredient.id;
          }
        );
        this.supplier = {
          ...data.supplier,
          supplierIngredient: supplierIngredientIDs,
        };
        this.previewProfilePic = data.supplier.profilePic;
      },
    },
    ingredients: {
      query: GetIngredients,
      fetchPolicy: "network-only",
      update: data => data.ingredientLists,
      result({ data }) {
        this.searchIngredients = data.ingredientLists;
      },
    },
  },

  data() {
    return {
      errorDialog: false,
      errorText: "",
      searchIngredientData: "",
      formValidated: false,
      supplierRules,
      selectedFile: null,
      previewProfilePic: null,
      selectedProfileFile: null,
      logoUrl: null,
      supplier: {
        id: "",
        supplierName: "",
        phoneNo: "",
        email: "",
        licenseNumber: "",
        countryId: "",
        city: "",
        zipcode: "",
        about: "",
        state: "",
        ingredients: [],
        supplierIngredient: [],
        profilePic: "",
      },
      countries,
      ingredients: [],
      searchIngredients: [],
    };
  },
  async mounted() {
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 3000);
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    supplierID: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    updateSupplierSubmit() {
      this.supplier.id = Number(this.supplier.id);

      this.startLoading();

      let formData = this.supplier;

      formData = {
        ...formData,
        ingredients: this.supplier["supplierIngredient"],
      };
      delete formData["supplierIngredient"];
      delete formData["__typename"];
      this.$apollo
        .mutate({
          mutation: updateSupplier,
          // parameters
          variables: {
            data: formData,
          },
        })
        .then(response => {
          if (response.data.updateSupplier) {
            this.$notify({
              title: "Supplier updated Successfully",
              text: "", //res.message,
              type: "success",
            });
            this.$emit("supplierUpdated");
            this.stopLoading();
          }
        })
        .catch(err => {
          console.log("catch error", err);
          this.$notify({
            title: "Supplier Not Updated",
            text: "",
            type: "error",
          });
          this.stopLoading();
        })
        .finally(() => {
          this.$emit("closeDialog");
        });
    },

    searchIngredient() {
      this.searchIngredients = this.ingredients.filter(ingredient => {
        return (
          ingredient.name
            .toLowerCase()
            .indexOf(this.searchIngredientData.toLowerCase()) > -1
        );
      });
    },

    uploadLogoChange(file) {
      this.selectedFile = file;
      if (this.selectedFile && !this.selectedFile.type.match("image.*")) {
        this.errorDialog = true;
        this.errorText = this.$t("pleaseChooseAnImageFile");
        this.logoUrl = null;
      }
      this.logoUrl = file;
    },

    onFileChanged(file) {
      this.selectedProfileFile = file;
      if (
        this.selectedProfileFile &&
        !this.selectedProfileFile.type.match("image.*")
      ) {
        this.errorDialog = true;
        this.errorText = this.$t("pleaseChooseAnImageFile");
        this.supplier.profilePic = null;
      }
      this.supplier.profilePic = file;
      this.previewProfilePic = URL.createObjectURL(file);
    },

    getFile() {
      let fileUpload = document.getElementById("fileUpload");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
  },
  mixins: [loadingMixin, generalMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-chip:not(.v-chip--active) {
  background: #ffb443;
  color: #ffffff;
}
</style>
